import { Http } from "../Http";
import { ApiResponse } from "../../../Api/Model/ApiResponse.csharp";
import { InsuranceMessageRequest } from "../../../Api/Insurance/InsuranceMessageRequest.csharp";
import { InsuranceErrorMessageRequest } from "../../../Api/Insurance/InsuranceErrorMessageRequest.csharp";

export interface IContactApi {
  sendMail(messageRequest: InsuranceMessageRequest): Promise<ApiResponse>;
  sendErrorMail(messageRequest: InsuranceErrorMessageRequest): Promise<ApiResponse>;
}

export class ContactApi implements IContactApi {
    public sendMail = (messageRequest: InsuranceMessageRequest): Promise<ApiResponse> => {
        return Http.post("/api/send-message/mail", messageRequest) as Promise<ApiResponse>;
    };
    public sendErrorMail = (messageRequest: InsuranceErrorMessageRequest): Promise<ApiResponse> => {
        return Http.post("/api/send-error-message/mail", messageRequest) as Promise<ApiResponse>;
    };
}
